import { IReduxAction } from '@bees-web/core/types'
import { SET_BRANDS_STORE } from '../constants/banners'
import { IBrandsState } from '../interfaces'

export const initialState: IBrandsState = {
  meta: null,
}

const brandsReducer = (
  state: IBrandsState = initialState,
  action: IReduxAction
) => {
  switch (action.type) {
    case SET_BRANDS_STORE:
      return {
        ...state,
        ...action.payload,
      }

    default:
      return state
  }
}

export default brandsReducer
